import React, { useState, useEffect } from "react";
import "react-nice-dates/build/style.css";
import {
  Modal,
  ModalHeader,
  ModalBody,
  CardTitle,
  Card,
  CardBody,
  CardSubtitle,
  CardFooter,
  Button,
  Input,
} from "reactstrap";
import CreateAPLPeriodGeneral from "./CreateAPLPeriodGeneral";
import CreateAPLPeriodDocuments from "./CreateAPLPeriodDocuments";
import CreateAPLPeriodWorkCard from "./CreateAPLPeriodWorkCard";
import CreateAPLPeriodSupervisor from "./CreateAPLPeriodSupervisor";
import APLRatingModal from "./APLRatingModal";
import {
  PostAplPeriod,
  PostAplInformationPerson,
  PostAplWorkCard,
} from "../../actions/teacherMutations";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";
import { FormattedMessage } from "react-intl";
import moment from "moment";
import APLInformationPersonModal from "./APLInformationPersonModal";
import APLCreateNewWorkCard from "../APL/APLCreateNewWorkCard";
import { v4 as uuid } from "uuid";
import AlertModal from "./AlertModal";
import axios from "../../services/api/api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AddItemWithOnlyNameModal from "../Modal/AddItemWithOnlyNameModal";

export default function CreateAPLPeriodModal({
  supervisors,
  students,
  toggle,
  isOpen,
  existingWorkCards,
  currentPeriods,
  setCurrentPeriods,
  handleSaveEvaluationQuestions,
  questionsToDelete,
  setQuestionsToDelete,
  schoolId,
  level,
  objId,
  programTeachers,
  teacherInfo,
}) {
  const [page, setPage] = useState(1);
  const [aplName, setAplName] = useState(null);
  const [aplStartDate, setAplStartDate] = useState(null);
  const [aplEndDate, setAplEndDate] = useState(null);
  const [aplHoursPerWeek, setAplHoursPerWeek] = useState(40);
  const [aplDaysPerWeek, setAplDaysPerWeek] = useState(5);
  const [aplStudentSupervisors, setAplStudentSupervisors] = useState([]);
  const [aplWorkcard, setWorkcard] = useState(null);
  const [aplDocumentsWithUsers, setAplDocumentsWithUsers] = useState([]);
  const [aplValidationErrors, setAplValidationErrors] = useState([]);
  const [aplWorkcardNameAlreadyExists, setAplWorkcardNameAlreadyExists] =
    useState(false);
  const [informationPersons, setInformationPersons] = useState([]);
  const [infoPersonUsers, setInfoPersonUsers] = useState([]);
  const [newStudentQuestions, setNewStudentQuestions] = useState([]);
  const [newSupervisorQuestions, setNewSupervisorQuestions] = useState([]);
  const [tableData, setTableData] = useState([
    {
      parentId: null,
      name: (
        <Button
          outline
          color="primary"
          onClick={() => setWorkItemToAdd({ parentId: null })}
        >
          <FormattedMessage id="AddWorkStep" />
        </Button>
      ),
      button: true,
    },
  ]);
  const [newWorkcardName, setNewWorkcardName] = useState("");
  const [defaultSelectedWorkCard, setDefaultSelectedWorkCard] = useState(null);
  const [availableStudents, setAvailableStudents] = useState([]);
  const [
    thereAreWorkStepsWithoutComponentsOrNoWorkSteps,
    setThereAreWorkStepsWithoutComponentsOrNoWorkSteps,
  ] = useState(false);
  const [workcardItemForEditName, setWorkcardItemForEditName] = useState(null);
  const [workcardItemForDelete, setWorkcardItemForDelete] = useState(null);
  const [workItemToAdd, setWorkItemToAdd] = useState(null);
  const handlehandleAddNewItem = (newItem) => {
    if (newItem.name !== "") {
      setTableData((prevState) => [newItem, ...prevState]);
    }
  };

  const postPeriodMutation = useMutation(PostAplPeriod);
  const postAplInfoPerson = useMutation(PostAplInformationPerson);
  const postWorkCardMutation = useMutation(PostAplWorkCard);
  const queryClient = useQueryClient();

  useEffect(() => {
    if (workcardItemForEditName !== null) {
      setTableData((data) => [
        ...data,
        (data.find((item) => item.id === workcardItemForEditName.id).name = (
          <Input
            defaultValue={workcardItemForEditName.name}
            onBlur={(data) =>
              setWorkcardItemForEditName({
                id: workcardItemForEditName.id,
                name: data.target.value,
                isWorkstep: false,
                parentId: workcardItemForEditName.parentId,
              })
            }
          />
        )),
      ]);
    }
  }, [workcardItemForEditName]);

  useEffect(() => {
    if (workcardItemForDelete !== null) {
      setTableData((data) =>
        data
          .filter((item) => item.id !== workcardItemForDelete.id)
          .filter((item) => item.parentId !== workcardItemForDelete.id)
      );
    }
  }, [workcardItemForDelete]);

  const clearWizardModal = () => {
    setPage(1);
    setAplName(null);
    setAplStartDate(null);
    setAplEndDate(null);
    setAplHoursPerWeek(40);
    setAplDaysPerWeek(5);
    setAplStudentSupervisors([]);
    setWorkcard(null);
    setAplDocumentsWithUsers([]);
    setAplValidationErrors([]);
    setInformationPersons([]);
    setInfoPersonUsers([]);
    setNewStudentQuestions([]);
    setNewSupervisorQuestions([]);
    setDefaultSelectedWorkCard(null);
    setTableData([
      {
        parentId: null,
        name: (
          <Button
            outline
            color="primary"
            onClick={() => setWorkItemToAdd({ parentId: null })}
          >
            <FormattedMessage id="AddWorkStep" />
          </Button>
        ),
        button: true,
      },
    ]);
  };

  const handleCloseModal = () => {
    clearWizardModal();
    toggle();
  };

  const handleSetName = (name) => {
    setAplName(name);
  };
  const handleSetStartDate = (date) => {
    setAplStartDate(date);
  };
  const handleSetEndDate = (date) => {
    setAplEndDate(date);
  };

  const handleSetHoursPerWeek = (hours) => {
    setAplHoursPerWeek(hours);
  };

  const handleSetDaysPerWeek = (days) => {
    setAplDaysPerWeek(days);
  };

  const toFormData = (file, paramName) => {
    if (!file) return null;

    var myData = new FormData();
    myData.append(paramName, file);
    return myData;
  };

  const handleAddAPLPeriod = () => {
    let participants = [];
    var docs = [];
    let tempAplStudentSupervisors = [...aplStudentSupervisors];
    tempAplStudentSupervisors.forEach((stud) => {
      let studentToAdd = {
        studentId: stud.id,
        companyId: 4,
        supervisors: stud.supervisors,
      };
      if (studentToAdd.supervisors.length === 0) {
        studentToAdd.supervisors.push({
          ...teacherInfo.data,
          IsMainResponsible: true,
        });
      }
      participants.push(studentToAdd);
    });
    let period = {
      name: aplName,
      start: moment(aplStartDate).format(),
      end: moment(aplEndDate).format(),
      hoursPerWeek: aplHoursPerWeek,
      daysPerWeek: aplDaysPerWeek,
      participants: participants,
      workCardId: aplWorkcard.id,
      documents: aplDocumentsWithUsers,
    };
    postPeriodMutation.mutate(period, {
      onSuccess: async (data) => {
        if (data && data.status > 199 && data.status < 300) {
          for (const doc of aplDocumentsWithUsers) {
            var userIds = [];
            for (let index = 0; index < doc.users.length; index++) {
              userIds.push(doc.users[index].value.id);
            }
            const docdata = await axios
              .post(
                `/Apl/PostDocumentForPeriod?description=${
                  doc.description
                }&periodId=${data.data.result.id}&userIds=${userIds.join(
                  "&userIds="
                )}`,
                toFormData(doc.document, "document"),
                { headers: { "Content-Type": "multipart/form-data;" } }
              )
              .catch((err) => {
                toast.warn(err.response.data);
              });
            if (docdata && docdata.status > 199 && docdata.status < 300) {
              docs.push(docdata.data.result);
            }
          }
          setAplDocumentsWithUsers([]);
          handleSaveEvaluationQuestions(
            data.data.result.id,
            newStudentQuestions,
            newSupervisorQuestions
          );

          infoPersonUsers.forEach((person) => {
            var forUserIds = [];
            person.forUsers.forEach((user) => {
              forUserIds.push(user.value.id);
            });

            postAplInfoPerson.mutate(
              {
                aplPeriodId: data.data.result.id,
                name: person.name,
                mail: person.mail,
                phoneNumber: person.phoneNumber,
                forUserIds: forUserIds,
              },
              {
                throwOnError: true,
                onError: (data) => {
                  toast.warn(data.response.data);
                },
              }
            );
          });
          var tempPeriods = [...currentPeriods];
          tempPeriods.push({
            period: data.data.result,
            documents: docs,
          });
          setCurrentPeriods(tempPeriods);
          clearWizardModal();
          queryClient.invalidateQueries(["FetchPeriods", [level, objId]]);
          toast.success(<FormattedMessage id="APLPeriodCreated" />);
        } else {
          toast.warn(data);
        }
      },
      throwOnError: true,
      onError: (data) => {
        toast.warn(data.response.data);
      },
    });
    toggle();
  };

  const renderHowTo = () => {
    switch (page) {
      case 0:
        return <></>;
      case 1:
        return (
          <p className="lead" style={{ fontSize: 14, whiteSpace: "pre-wrap" }}>
            <FormattedMessage id="YouAreAboutToCreateANewAplPeriod" />
          </p>
        );
      case 2:
        return (
          <p className="lead" style={{ fontSize: 14, whiteSpace: "pre-wrap" }}>
            <FormattedMessage id="HowToStepTwo" />
          </p>
        );
      case 3:
        return (
          <p className="lead" style={{ fontSize: 14, whiteSpace: "pre-wrap" }}>
            <FormattedMessage id="HowToStepThree" />
          </p>
        );
      case 4:
        return (
          <p className="lead" style={{ fontSize: 14, whiteSpace: "pre-wrap" }}>
            <FormattedMessage id="HowToStepFour" />
          </p>
        );
      case 5:
        return (
          <p className="lead" style={{ fontSize: 14, whiteSpace: "pre-wrap" }}>
            <FormattedMessage id="HowToStepFive" />
          </p>
        );
      case 6:
        return (
          <p className="lead" style={{ fontSize: 14, whiteSpace: "pre-wrap" }}>
            <FormattedMessage id="HowToStepSix" />
          </p>
        );
      case 7:
        return (
          <p className="lead" style={{ fontSize: 14, whiteSpace: "pre-wrap" }}>
            <FormattedMessage id="HowToStepSeven" />
          </p>
        );
      default:
        return (
          <p className="lead" style={{ fontSize: 14, whiteSpace: "pre-wrap" }}>
            <FormattedMessage id="WorkcardForPeriod" />
          </p>
        );
    }
  };

  const renderTitle = () => {
    switch (page) {
      case 0:
        return (
          <p className="lead">
            <FormattedMessage id="AddWorkCard" />
          </p>
        );
      case 1:
        return (
          <p className="lead">
            <FormattedMessage id="WorkcardForPeriod" />
          </p>
        );
      case 2:
        return (
          <p className="lead">
            <FormattedMessage id="General" />
          </p>
        );
      case 3:
        return (
          <p className="lead">
            <FormattedMessage id="SupervisorsAndStudents" />
          </p>
        );
      case 4:
        return (
          <p className="lead">
            <FormattedMessage id="SaveOrContinue" />
          </p>
        );
      case 5:
        return (
          <p className="lead">
            <FormattedMessage id="ContactPersons" />
          </p>
        );
      case 6:
        return (
          <p className="lead">
            <FormattedMessage id="Ratings" />
          </p>
        );
      case 7:
        return (
          <p className="lead">
            <FormattedMessage id="Documents" />
          </p>
        );
      default:
        return (
          <p className="lead">
            <FormattedMessage id="WorkcardForPeriod" />
          </p>
        );
    }
  };

  const calculateSelectableStudents = (aplStartDate, aplEndDate) => {
    let studentsIdsInCollidingPeriods = [];
    currentPeriods.forEach((existingPeriod) => {
      if (
        (moment(aplStartDate).unix() >=
          moment(existingPeriod.period.from).unix() &&
          moment(aplStartDate).unix() <=
            moment(existingPeriod.period.to).unix()) ||
        (moment(aplEndDate).unix() >=
          moment(existingPeriod.period.from).unix() &&
          moment(aplStartDate).unix() <=
            moment(existingPeriod.period.to).unix())
      ) {
        existingPeriod.period.students.forEach((student) => {
          studentsIdsInCollidingPeriods.push(student.student.id);
        });
      }
    });
    let tempAvailableStudents = students.filter(
      (student) => !studentsIdsInCollidingPeriods.includes(student.id)
    );
    setAvailableStudents(tempAvailableStudents);
  };

  const handleSetNextPage = () => {
    if (page === 1) {
      if (aplWorkcard === null) {
        setAplValidationErrors([...aplValidationErrors, "aplWorkcard"]);
      } else {
        setAplValidationErrors(
          aplValidationErrors.filter((item) => item !== "aplWorkcard")
        );
        setPage(page + 1);
      }
    } else if (page === 2 && (aplName === null || aplName === "")) {
      setAplValidationErrors([...aplValidationErrors, "aplName"]);
    } else if (
      page === 2 &&
      (aplStartDate === null ||
        aplStartDate === "" ||
        aplEndDate === null ||
        aplEndDate === "")
    ) {
      setAplValidationErrors([...aplValidationErrors, "aplDate"]);
    } else {
      setAplValidationErrors(
        aplValidationErrors.filter((item) => item !== "aplName" || "aplDate")
      );
      calculateSelectableStudents(aplStartDate, aplEndDate);
      setPage(page + 1);
    }
  };

  const handleToggleWorkCardCreateOpen = () => {
    setPage(1);
  };

  const handleSetNameForNewWorkcard = (name) => {
    if (name.length > 0) {
      if (existingWorkCards.some((e) => e.name === name)) {
        if (aplWorkcardNameAlreadyExists === false) {
          setAplWorkcardNameAlreadyExists(true);
        }
      } else {
        if (aplWorkcardNameAlreadyExists === true) {
          setAplWorkcardNameAlreadyExists(false);
        }
      }
      setNewWorkcardName(name);
      if (aplValidationErrors.includes("aplCreateWorkcardNoName")) {
        setAplValidationErrors(
          aplValidationErrors.filter(
            (item) => item !== "aplCreateWorkcardNoName"
          )
        );
      }
    } else {
      if (setAplWorkcardNameAlreadyExists) {
        setAplWorkcardNameAlreadyExists(false);
      }
      if (aplValidationErrors.includes("aplCreateWorkcardNoName")) {
        setAplValidationErrors([
          ...aplValidationErrors,
          "aplCreateWorkcardNoName",
        ]);
      }
    }
  };

  const handlePostWorkCard = (continueToNextStepWhenPosted) => {
    if (newWorkcardName.length < 1) {
      setAplValidationErrors([
        ...aplValidationErrors,
        "aplCreateWorkcardNoName",
      ]);
    } else if (
      !aplValidationErrors.includes("aplCreateWorkcardNoName") &&
      !aplWorkcardNameAlreadyExists
    ) {
      let data = tableData.filter((item) => item.button === undefined);
      let workSteps = data.filter((item) => item.parentId === null);
      let workCard = { Name: newWorkcardName, WorkSteps: [] };
      workSteps.forEach((ws) => {
        let workStep = {
          Name: ws.name.props.defaultValue,
          WorkStepComponents: [],
        };
        data.forEach((item) => {
          if (item.parentId === ws.id) {
            workStep.WorkStepComponents.push({
              Name: item.name.props.defaultValue,
            });
          }
        });
        workCard.WorkSteps.push(workStep);
      });
      let cancelPost = false;
      if (workCard.WorkSteps.length < 1) {
        setThereAreWorkStepsWithoutComponentsOrNoWorkSteps(true);
        cancelPost = true;
      }
      workCard.WorkSteps.forEach((ws) => {
        if (ws.WorkStepComponents.length < 1) {
          setThereAreWorkStepsWithoutComponentsOrNoWorkSteps(true);
          cancelPost = true;
        }
      });

      if (!cancelPost) {
        postWorkCardMutation.mutate(workCard, {
          onSuccess: (data) => {
            if (data && data.status > 199 && data.status < 300) {
              toast.success(<FormattedMessage id="WorkCardAdded" />);
              queryClient.invalidateQueries("FetchWorkCards");
              setWorkcard(data.data.result);
              setDefaultSelectedWorkCard(data.data.result);
              setAplValidationErrors(
                aplValidationErrors.filter((item) => item !== "aplWorkcard")
              );
            } else {
              toast.warn(data);
            }
            if (continueToNextStepWhenPosted) {
              setPage(2);
            } else {
              setPage(1);
            }
          },
          throwOnError: true,
          onError: (data) => {
            toast.warn(data.response.data);
          },
        });
      }
    }
  };

  const renderNextButton = () => {
    if (page === 0) {
      return (
        <>
          <Button
            color="primary"
            outline
            className="m-2"
            onClick={() => handlePostWorkCard(false)}
          >
            <FormattedMessage id="AddWorkCard" />
          </Button>
          <Button
            color="primary"
            outline
            className="m-2"
            onClick={() => handlePostWorkCard(true)}
          >
            <FormattedMessage id="AddWorkCardAndContinue" />
          </Button>
        </>
      );
    } else if (page === 4) {
      return (
        <>
          <Button
            color="primary"
            outline
            className="m-2"
            onClick={() => handleAddAPLPeriod()}
          >
            <FormattedMessage id="AddPeriodAndClose" />
          </Button>
          <Button
            id="NextButton"
            color="primary"
            outline
            disabled={
              (page === 2 &&
                aplValidationErrors.some(
                  (item) =>
                    item === "aplName" ||
                    "aplDate" ||
                    "aplHoursPerWeek" ||
                    "aplDaysPerWeek"
                )) ||
              (page === 1 && !aplWorkcard) ||
              (page === 3 &&
                (aplStudentSupervisors.length === 0 ||
                  !aplStudentSupervisors?.some(
                    (sv) => sv.students.length > 0
                  ) ||
                  aplStudentSupervisors?.some((sv) =>
                    sv.students.some(
                      (stud) =>
                        stud.companyId === undefined || stud.companyId === null
                    )
                  )))
            }
            className="m-2"
            onClick={() => handleSetNextPage()}
          >
            <FormattedMessage id="Next" />
          </Button>
        </>
      );
    } else if (page < 7 && page > 0) {
      return (
        <Button
          id="NextButton"
          color="primary"
          outline
          disabled={
            (page === 2 &&
              aplValidationErrors.some(
                (item) =>
                  item === "aplName" ||
                  "aplDate" ||
                  "aplHoursPerWeek" ||
                  "aplDaysPerWeek"
              )) ||
            (page === 1 && !aplWorkcard) ||
            (page === 3 && aplStudentSupervisors.length === 0)
          }
          className="m-2"
          onClick={() => handleSetNextPage()}
        >
          <FormattedMessage id="Next" />
        </Button>
      );
    } else {
      return (
        <Button
          color="primary"
          outline
          className="m-2"
          onClick={() => handleAddAPLPeriod()}
        >
          <FormattedMessage id="AddPeriod" />
        </Button>
      );
    }
  };

  const handleSelectWorkCardTemplate = (selected) => {
    let tempTableData = [];
    selected.value.workSteps.forEach((wsi) => {
      const wsToAdd = {
        id: "ws" + wsi.id,
        edit: (
          <>
            <Button
              color="danger"
              outline={true}
              size="sm"
              onClick={() =>
                setWorkcardItemForDelete({
                  id: "ws" + wsi.id,
                  name: wsi.name,
                  isWorkstep: true,
                  hours: wsi.hours,
                  parentId: null,
                })
              }
            >
              <FontAwesomeIcon icon="trash" />
            </Button>
          </>
        ),
        parentId: null,
        name: (
          <Input
            defaultValue={wsi.name}
            onBlur={(data) =>
              setWorkcardItemForEditName({
                id: "ws" + wsi.id,
                name: data.target.value,
                isWorkstep: false,
                parentId: wsi.parentId,
              })
            }
          />
        ),
      };
      tempTableData.push(wsToAdd);
      wsi.workStepComponents.forEach((wsc) => {
        const wscToAdd = {
          id: "wsc" + wsc.id,
          edit: (
            <>
              <Button
                color="danger"
                outline={true}
                size="sm"
                onClick={() =>
                  setWorkcardItemForDelete({
                    id: "wsc" + wsc.id,
                    name: wsc.name,
                    isWorkstep: false,
                    hours: wsc.hours,
                    parentId: "ws" + wsi.id,
                  })
                }
              >
                <FontAwesomeIcon icon="trash" />
              </Button>
            </>
          ),
          name: (
            <Input
              defaultValue={wsc.name}
              onBlur={(data) =>
                setWorkcardItemForEditName({
                  id: "wsc" + wsc.id,
                  name: data.target.value,
                  isWorkstep: false,
                  parentId: "ws" + wsi.id,
                })
              }
            />
          ),
          parentId: "ws" + wsi.id,
        };
        tempTableData.push(wscToAdd);
      });
    });
    const tempWorkSteps = tempTableData.filter(
      (item) => item.parentId === null
    );
    tempWorkSteps.forEach((ws) => {
      tempTableData.push({
        parentId: ws.id,
        name: (
          <Button
            outline
            color="primary"
            onClick={() => setWorkItemToAdd({ parentId: ws.id })}
          >
            <FormattedMessage id="AddWorkStepComponent" />
          </Button>
        ),
        button: true,
      });
    });
    tempTableData.push({
      parentId: null,
      name: (
        <Button
          outline
          color="primary"
          onClick={() => setWorkItemToAdd({ parentId: null })}
        >
          <FormattedMessage id="AddWorkStep" />
        </Button>
      ),
      button: true,
    });
    setTableData(tempTableData);
  };

  const handleCloseCreateNewWorkcardPage = () => {
    setNewWorkcardName("");
    setTableData([
      {
        parentId: null,
        name: (
          <Button
            outline
            color="primary"
            onClick={() => setWorkItemToAdd({ parentId: null })}
          >
            <FormattedMessage id="AddWorkStep" />
          </Button>
        ),
        button: true,
      },
    ]);
    setPage(1);
    setAplValidationErrors(
      aplValidationErrors.filter((item) => item !== "aplCreateWorkcardNoName")
    );
  };

  const handleAddWorkcardItem = (name) => {
    const tempTableData = [...tableData];
    const id = workItemToAdd.parentId === null ? "ws" + uuid() : "wsc" + uuid();
    const itemToAdd = {
      id: id,
      edit: (
        <>
          <Button
            color="danger"
            outline={true}
            size="sm"
            onClick={() =>
              setWorkcardItemForDelete({
                id: id,
                name: name,
                isWorkstep: false,
                parentId: workItemToAdd.parentId,
              })
            }
          >
            <FontAwesomeIcon icon="trash" />
          </Button>
        </>
      ),
      name: (
        <Input
          defaultValue={name}
          onBlur={(data) =>
            setWorkcardItemForEditName({
              id: id,
              name: data.target.value,
              isWorkstep: false,
              parentId: workItemToAdd.parentId,
            })
          }
        />
      ),
      parentId: workItemToAdd.parentId,
    };
    if (workItemToAdd.parentId !== null) {
      tempTableData.splice(
        tempTableData.findIndex(
          (item) =>
            item.parentId === workItemToAdd.parentId && item.button === true
        ) - 1,
        0,
        itemToAdd
      );
    } else {
      tempTableData.splice(tempTableData.length - 2, 0, itemToAdd);
      tempTableData.push({
        parentId: itemToAdd.id,
        name: (
          <Button
            outline
            color="primary"
            onClick={() => setWorkItemToAdd({ parentId: itemToAdd.id })}
          >
            <FormattedMessage id="AddWorkStepComponent" />
          </Button>
        ),
        button: true,
      });
    }
    const addWorkStepButtonIndex = tempTableData.findIndex(
      (item) => item.parentId === null && item.button === true
    );
    tempTableData.push(tempTableData.splice(addWorkStepButtonIndex, 1)[0]);
    setTableData(tempTableData);
    setWorkItemToAdd(null);
  };

  const renderStep = () => {
    switch (page) {
      case 0:
        return (
          <>
            <APLCreateNewWorkCard
              existingWorkCards={existingWorkCards}
              handleToggleWorkCardCreateOpen={handleToggleWorkCardCreateOpen}
              tableData={tableData}
              handleAddNewItem={handlehandleAddNewItem}
              handleSelectWorkCardTemplate={handleSelectWorkCardTemplate}
              setNewWorkcardName={handleSetNameForNewWorkcard}
              aplValidationErrors={aplValidationErrors}
              setAplValidationErrors={setAplValidationErrors}
              aplWorkcardNameAlreadyExists={aplWorkcardNameAlreadyExists}
            />
            <AddItemWithOnlyNameModal
              close={() => setWorkItemToAdd(null)}
              isOpen={workItemToAdd !== null}
              onProceed={handleAddWorkcardItem}
            />
          </>
        );
      case 1:
        return (
          <CreateAPLPeriodWorkCard
            aplValidationErrors={aplValidationErrors}
            setAplValidationErrors={setAplValidationErrors}
            setWorkcard={setWorkcard}
            aplWorkcard={aplWorkcard}
            existingWorkCards={existingWorkCards}
            setPage={setPage}
            defaultSelectedWorkCard={defaultSelectedWorkCard}
          />
        );
      case 2:
        return (
          <CreateAPLPeriodGeneral
            setAplValidationErrors={setAplValidationErrors}
            aplValidationErrors={aplValidationErrors}
            aplName={aplName}
            aplStartDate={aplStartDate}
            aplEndDate={aplEndDate}
            aplHoursPerWeek={aplHoursPerWeek}
            aplDaysPerWeek={aplDaysPerWeek}
            handleSetDaysPerWeek={handleSetDaysPerWeek}
            handleSetHoursPerWeek={handleSetHoursPerWeek}
            handleSetName={handleSetName}
            handleSetStartDate={handleSetStartDate}
            handleSetEndDate={handleSetEndDate}
          />
        );
      case 3:
        return (
          <CreateAPLPeriodSupervisor
            students={availableStudents}
            supervisors={supervisors}
            aplStudentSupervisors={aplStudentSupervisors}
            setAplStudentSupervisors={setAplStudentSupervisors}
            schoolId={schoolId}
            programTeachers={programTeachers}
            isOpen={isOpen}
          />
        );
      case 4:
        return <></>;
      case 5:
        return (
          <APLInformationPersonModal
            setInformationPersons={setInformationPersons}
            informationPersons={informationPersons}
            infoPersonUsers={infoPersonUsers}
            setInfoPersonUsers={setInfoPersonUsers}
            aplStudentSupervisors={aplStudentSupervisors}
          />
        );

      case 6:
        return (
          <APLRatingModal
            newStudentQuestions={newStudentQuestions}
            setNewStudentQuestions={setNewStudentQuestions}
            newSupervisorQuestions={newSupervisorQuestions}
            setNewSupervisorQuestions={setNewSupervisorQuestions}
            questionsToDelete={questionsToDelete}
            setQuestionsToDelete={setQuestionsToDelete}
          />
        );
      case 7:
        return (
          <CreateAPLPeriodDocuments
            aplDocumentsWithUsers={aplDocumentsWithUsers}
            setAplDocumentsWithUsers={setAplDocumentsWithUsers}
            aplStudentSupervisors={aplStudentSupervisors}
          />
        );
      default:
        return <CreateAPLPeriodGeneral />;
    }
  };

  return (
    <>
      <Modal
        size="xl"
        isOpen={isOpen}
        toggle={handleCloseModal}
        backdrop="static"
        className="apl--modal"
      >
        <ModalHeader>
          <FormattedMessage id="NewAplPeriod" />
        </ModalHeader>
        <Card style={{ marginBottom: "0" }}>
          <CardBody>
            <CardTitle>{renderTitle()}</CardTitle>

            <CardTitle>{renderHowTo()}</CardTitle>

            <ModalBody style={{ border: "none", padding: "0" }}>
              {renderStep()}
            </ModalBody>
          </CardBody>
          <CardFooter>
            <CardSubtitle style={{ position: "absolute", marginTop: "1rem" }}>
              <p className="small">
                <FormattedMessage id="Page" /> {page}/7
              </p>
            </CardSubtitle>
            <div className="justify-content-end d-flex">
              {page === 0 ? (
                <Button
                  outline
                  className="m-2"
                  color="secondary"
                  onClick={() => handleCloseCreateNewWorkcardPage()}
                >
                  <FormattedMessage id="Cancel" />
                </Button>
              ) : (
                <Button
                  outline
                  className="m-2"
                  color="secondary"
                  onClick={handleCloseModal}
                >
                  <FormattedMessage id="Cancel" />
                </Button>
              )}
              {page > 1 ? (
                <Button
                  color="primary"
                  outline
                  className="m-2"
                  onClick={() => setPage(page - 1)}
                >
                  <FormattedMessage id="Previous" />
                </Button>
              ) : null}
              {renderNextButton()}
            </div>
          </CardFooter>
        </Card>
      </Modal>
      <AlertModal
        close={() => setThereAreWorkStepsWithoutComponentsOrNoWorkSteps(false)}
        isOpen={thereAreWorkStepsWithoutComponentsOrNoWorkSteps}
        title={<FormattedMessage id="WorkStepsErrorOnCreate" />}
        message={<FormattedMessage id="WorkStepsErrorText" />}
      />
    </>
  );
}
